// extracted by mini-css-extract-plugin
export default {"button":"pdfDownload_button__QNb5d"};